module.exports = __webpack_public_path__ + "img/shape2.e8de989c.svg";